<div class="cell-with-logo-wrapper">
    @if (logoUrl()) {
        <div class="logo-container">
            <img class="logo" [alt]="displayValue() | translate" [src]="cachedLogoUrl()" />
        </div>
    }
    @if (displayValue()) {
        <span>{{ displayValue() | translate }}</span>
    }

    @if (infoTooltipText()) {
        <div
            class="channel-info"
            appTooltip
            trigger="hover"
            position="right"
            [componentData]="infoTooltipText()"
            [showDelay]="200"
            [hideDelay]="200"
        >
            <i class="fa fa-regular fa-info-circle"></i>
        </div>
    }
</div>
